<template>
    <div class="as-schematic">
        <div class="as-schematic__head">
            <span>Tứ kết</span>
            <span>Bán kết</span>
            <span>Chung kết</span>
        </div>
        <!-- <span>Quarter-finals</span>
<span>Semi-finals</span>
<span>Finals</span> -->
        <div class="as-schematic__body">
            <div class="as-quarter">
              <SchematicItem/>
              <SchematicItem/>
              <SchematicItem/>
              <SchematicItem/>
            </div>
            <div class="as-connecter">
              <div></div>
              <div></div>
            </div>
            <div class="as-line">
              <div></div>
              <div></div>
            </div>
            <div class="as-semi">
              <SchematicItem/>
              <SchematicItem/>
            </div>
            <div class="as-connecter as-connecter__semi">
              <div></div>
            </div>
            <div class="as-line as-line__semi">
              <div></div>
            </div>
            <div class="as-finals">
              <SchematicItem :isNull="true" />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import type { IMatch } from "~src/interfaces/tennis";
import SchematicItem from "./SchematicItem.vue";
interface IProps {
    schematics: string[];
    match: IMatch;
    isHomePage: boolean;
  }

withDefaults(defineProps<IProps>(), {
  isHomePage: false
});
</script>

<script lang="ts">
export default {};
</script>
